import { Container, Text, Link } from "basis";
import { usePageTracking } from "react-event-tracker";
import { getRegional } from "library/getRegional";

import gemVisa from "../../images/promo-gem-visa.png";
import degrees28 from "../../images/promo-28-degrees.png";

import { Layout } from "../layout";
import styles from "./logout.module.scss";

export const LogoutPage = () => {
  usePageTracking({
    page: {
      pageType: "information-page",
      siteSection: "sign-out",
      siteSubSection: "",
      pageTitle: "sign-out",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });
  const isNZ = getRegional("code") === "NZ";
  const adImageSrc = isNZ ? gemVisa : degrees28;

  return (
    <Layout hideIA unAuthLayout>
      <div className={styles.layout}>
        <div className={`${styles.wrapper} ${styles.staticDetails}`}>
          <div className={styles.panel}>
            <section>
              <h1 className={`h4 ${styles.loggedOut}`}>
                You have been logged out.
              </h1>
              <Text>
                Thanks for using your Latitude account.
                <br />
                We hope to see you again soon!
              </Text>
              <h2 className={`h4 ${styles.whereTo}`}>Where to from here?</h2>
              <Text margin="0 0 5 0">You can visit all our products here:</Text>
              <Container width="200" margin="0 auto">
                <Link
                  appearance="secondary-button"
                  width="100%"
                  href={
                    isNZ
                      ? "https://www.gemfinance.co.nz"
                      : "https://latitudefinancial.com"
                  }
                  newTab
                >
                  {isNZ
                    ? "Visit Gem Finance Website"
                    : "Visit Latitude Financial Website"}
                </Link>
                <Container margin="4 auto">
                  <Text align="center">or</Text>
                </Container>
                <Link
                  appearance="secondary-button"
                  width="100%"
                  href="/login"
                  newTab={false}
                >
                  Log back in
                </Link>
              </Container>
            </section>
            <aside>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  isNZ
                    ? "https://www.gemfinance.co.nz"
                    : "https://latitudefinancial.com"
                }
              >
                <img src={adImageSrc} alt="advertisement" />
              </a>
            </aside>
          </div>
        </div>
      </div>
    </Layout>
  );
};
